import styled from "styled-components";

// export const Title = styled.h1`
//     font-weight: 700;
//     font-size: 36px;
//     line-height: 50px;
//     font-family: 'Inter', sans-serif;
// `;

// export const Subitle = styled.h1`
//     font-weight: 600;
//     font-size: 18px;
//     font-family: 'Inter', sans-serif;
// `;

// export const Word = styled.p`
//     font-weight: 400;
//     font-size: 16px;
//     line-height: 25px;
//     font-family: 'Inter', sans-serif;
// `;

// export const Image = styled.img`
//     display: block;
//     margin-left: auto;
//     margin-right: 0;
//     width: 70%;
// `;

// export const LightBg = styled.div`
//     font-family: Inter;
//     padding: 75px 125px;
//     background: #FFFFFF;
//     font-family: 'Inter', sans-serif;
// `;

// export const PurpleBg = styled.div`
//     font-family: Inter;
//     padding: 75px 125px;
//     background: #6554C0;
//     color: #FFFFFF;
//     font-family: 'Inter', sans-serif;
// `;

export const ParentCard = styled.div`
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    align-items: flex-start;
    margin-top: 50px;
    margin-bottom: 50px;
    gap: 1rem;
    font-family: 'Inter', sans-serif;
`;

export const LCard = styled.div`
    display: flex;
    box-sizing: border-box;
    background: #FFFFFF;
    color: #000000;
    text-align: left;
    width: 300px;
    height: 100%;
    border-radius: 10px;
    padding: 20px;
    flex-direction: column;
    cursor: pointer;
    font-family: 'Inter', sans-serif;
`;

  